import React from 'react'
import clsx from 'clsx'
import WarningIcon from '@mui/icons-material/Warning'
import ListItem, { ErrorListItemProps } from './ErrorListItem'

export type ErrorListProps = {
	title?: string
	errors: ErrorListItemProps['error'][]
	className?: string
}

const ErrorList = ({
	title,
	errors = [],
	className,
}: ErrorListProps) => {
	if (errors.length === 0) return null

	return (
		<div className={clsx('bg-red-100 p-3 rounded', className)}>
			{title && <h2 className="text-red-700 text-lg">{title}</h2>}
			<div className="flex items-center">
				<WarningIcon className="text-red-700 mr-2" />
				<ul className="list-disc pl-2 ml-2">
					{errors.map((error) => (
						<li
							key={
								typeof error === 'object' ? error.errorMessage : error
							}
							className="text-red-700 text-sm"
						>
							<ListItem error={error} />
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}

export default ErrorList
